import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
    dialog: PropTypes.node,
}

const DialogWrapper = ({ dialog }) => (
    <div>{dialog}</div>
)

DialogWrapper.propTypes = propTypes

export default DialogWrapper



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/index.js